import * as act from '@/store/document-signatures.temp.actions';
import { documentSignsService } from '@/services';

class DocumentSignaturesState {
  signatures: Map<string, Array<any>> = new Map()
}

const state = new DocumentSignaturesState();

const actions = {
  async [act.ACT_LOAD_SIGNATURES]({ commit }, { documentVersionCode, documentAccessToken, forceReload }) {
    if (forceReload || !state.signatures.has(documentVersionCode)) {
      let signatures = await documentSignsService.allUserSignsGet(documentVersionCode, '', documentAccessToken);
      commit(act.MUT_SAVE_SIGNATURES, { documentVersionCode, signatures });
    }
  }
};

const mutations = {
  [act.MUT_SAVE_SIGNATURES](state: DocumentSignaturesState, { documentVersionCode, signatures }): void {
    state.signatures.set(documentVersionCode, signatures);
  },
  [act.MUT_CLEAR_SIGNATURES](state: DocumentSignaturesState, { documentVersionCode }): void {
    state.signatures.delete(documentVersionCode);
  }
};

const getters = {
  [act.GET_SIGNATURES]: (state: DocumentSignaturesState) => (documentVersionCode: string) => {
    return state.signatures.has(documentVersionCode) ? state.signatures.get(documentVersionCode) : [];
  }
};

export const documentSignaturesTemp = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
